import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import StudentLogin from '../components/StudentLogin';
import axios from 'axios';
import { API_BASE_URL } from '../utils/api';

const StudentLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { studentLogin } = useAuth();

  const handleLogin = async (email: string, password: string) => {
    await studentLogin(email, password);
    
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API_BASE_URL}/api/student/diagnostic/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.completed) {
        navigate('/student/dashboard');
        return;
      }
    } catch {
      // If check fails, fall through to assessment page
    }
    navigate('/student/assessment');
  };

  const handleSwitchToTeacher = () => {
    navigate('/login');
  };

  return (
    <StudentLogin 
      onLogin={handleLogin}
      onSwitchToTeacher={handleSwitchToTeacher}
    />
  );
};

export default StudentLoginPage;

